import React from 'react';
import { 
  HelpCircle, 
  PieChart, 
  Clock, 
  Percent, 
  Shield, 
  AlertTriangle, 
  TrendingUp,
  Landmark
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: PieChart,
      title: 'Диверсификация',
      description: 'Не вкладывайте все в одну криптовалюту. Распределите инвестиции между разными активами.'
    },
    {
      icon: Clock,
      title: 'Долгосрочная перспектива',
      description: 'Криптовалюты волатильны в краткосрочной перспективе, но могут показать рост в долгосрочной.'
    },
    {
      icon: Percent,
      title: 'DCA-стратегия',
      description: 'Используйте стратегию усреднения (DCA) – регулярно инвестируйте фиксированную сумму.'
    },
    {
      icon: Landmark,
      title: 'Выбор площадки',
      description: 'Выбирайте проверенные биржи с хорошей репутацией и высоким уровнем безопасности.'
    },
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'Храните значительные суммы на аппаратных кошельках, а не на биржах.'
    },
    {
      icon: AlertTriangle,
      title: 'Управление рисками',
      description: 'Инвестируйте только те средства, потерю которых вы можете себе позволить.'
    },
    {
      icon: TrendingUp,
      title: 'Технический анализ',
      description: 'Используйте технический анализ для выбора оптимальных точек входа в рынок.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы для криптоинвесторов
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="w-5 h-5 text-amber-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-amber-700 dark:text-amber-300 mb-2">
              Внимание: высокий риск
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400 mb-3">
              Криптовалютные инвестиции сопряжены с высоким риском. Стоимость активов может значительно колебаться.
            </p>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              В России операции с криптовалютой регулируются Федеральным законом "О цифровых финансовых активах". Обязательно ознакомьтесь с актуальным законодательством.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;